"use client";

import { cn } from "@faire/react/tools/cn";
import {
  PopoverContent,
  popoverVars,
} from "@faire/slate/private/popover/PopoverContent";
import React from "react";

type IProps = React.ComponentProps<typeof PopoverContent> & {
  zIndex?: number;
};

export const TooltipContent: React.FC<IProps> = ({
  zIndex,
  style,
  className,
  ...props
}) => {
  const tooltipVars = popoverVars({ zIndex });
  const tooltipCls = cn("fs-tooltip", className);

  return (
    <PopoverContent
      style={{ ...tooltipVars, ...style }}
      {...props}
      className={tooltipCls}
    />
  );
};
